import React, { Fragment } from "react";
import IndustriesTile from "./IndustriesTile";
import { BarLoader } from "react-spinners";

import PropTypes from "prop-types";

class Industries extends React.Component {
    render() {
        const { industries, isTileActive } = this.props;
        const ln = industries.length;

        return (
            <Fragment>
                <div className="tiles-container">
                    <nav className="tile-row" role="navigation">
                        {ln > 0 ? (
                            industries
                                .sort(function(a, b) {
                                    let initial = a.name.toLowerCase(),
                                        next = b.name.toLowerCase();
                                    if (initial < next) return -1;
                                    if (initial > next) return 1;
                                    return 0;
                                })
                                .map((industries, i) => (
                                    <IndustriesTile
                                        {...this.props}
                                        active={isTileActive}
                                        i={i}
                                        key={industries.id}
                                        industries={industries}
                                        type="industries"
                                    />
                                ))
                        ) : (
                            <div className="spinner-holder">
                                <BarLoader color={"#150F96"} />
                            </div>
                        )}
                    </nav>
                </div>
            </Fragment>
        );
    }
}

export default Industries;



// WEBPACK FOOTER //
// ./src/components/Industries.js